function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface11731429"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.215687%,70.19608%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 5.414062 2.328125 L 13.296875 10.535156 L 15.625 8.109375 C 11.613281 5.839844 6.300781 2.835938 5.414062 2.328125 Z M 3.140625 2.847656 C 3.054688 3.046875 3 3.261719 3 3.503906 L 3 20.589844 C 3 20.789062 3.042969 20.96875 3.109375 21.140625 L 11.910156 11.976562 Z M 17.421875 9.125 L 14.683594 11.980469 L 17.402344 14.8125 C 19.070312 13.867188 20.226562 13.210938 20.226562 13.210938 C 20.726562 12.90625 21.003906 12.441406 20.996094 11.933594 C 20.992188 11.4375 20.703125 10.980469 20.222656 10.710938 C 20.160156 10.675781 19.03125 10.035156 17.421875 9.128906 Z M 13.296875 13.421875 L 5.472656 21.566406 C 6.820312 20.800781 11.796875 17.980469 15.605469 15.824219 Z M 13.296875 13.421875 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googlePlay.39e5b541.svg";
export { ForwardRef as ReactComponent };